const verticalActions = {
    changeVertical: verticalId => ({
        type: 'CHANGE_VERTICAL',
        payload: {
            verticalId
        }
    }),
    setVertical: verticalId => ({
        type: 'SET_VERTICAL',
        payload: {
            verticalId
        }
    })
};

export default verticalActions;



// WEBPACK FOOTER //
// ./src/pages/Search/actions/verticalActions.js